import { Property } from '@/api/types/categories.types';

export const initialGroupedProperties = {
  booleanProperties: new Set<Property>(),
  restProperties: new Set<Property>(),
};

export const PRICE_INPUT_PRECISION = 2;

export const PRICE_INPUT_MAX_LENGTH = 15;
